// extracted by mini-css-extract-plugin
module.exports = {"backTopBtn":"app_backTopBtn__XidYr"};